import ApplicationController from './application_controller'

export default class SizeChartController extends ApplicationController {
  static targets = ['data', 'loader', 'toggleUnit']

  static values = {
    canvas: String
  }

  connect() {
    document.unit = 'in'
  }

  fetch_data() {
    this.dataTarget.innerHTML = '';
    this.showLoader();

    var options = TeePublic.ProductHelper.collectSelections('form.jsConfigOptions', TeePublic.ProductOptions, false);

    let url = `size_chart_dialog?canvas=${this.canvasValue}`;

    if (options['style']) {
      url += `&style=${options['style']}`;
    }

    if (options['gender']) {
      url += `&fit=${options['gender']}`;
    }

    const urlWithParams = `/${url}`;
    const opts = { method: 'GET' }

    fetch(urlWithParams, opts)
      .then(response => response.text())
      .then((data) => {
        this.hideLoader();
        this.dataTarget.innerHTML = data;
      })
      .catch((error) => {
        this.handleError(error);
      });
  }

  hideLoader() {
    this.loaderTarget.classList.add('hidden');
  }

  showLoader() {
    this.loaderTarget.classList.remove('hidden');
  }

  toggleUnit() {
    document.unit = document.unit === 'in' ? 'cm' : 'in'
    this.updateDisplay(document.unit)
  }

  updateDisplay() {
    const inSections = document.querySelectorAll('.jsSizeChartIn')
    const cmSections = document.querySelectorAll('.jsSizeChartCm')
    const toggleLabels = document.querySelectorAll('.jsToggleSizeChartLabel')

    if (document.unit === 'in') {
      inSections.forEach(el => el.classList.remove('hidden'))
      cmSections.forEach(el => el.classList.add('hidden'))
      toggleLabels.forEach(el => { el.textContent = 'Switch to: CM' })
    } else {
      cmSections.forEach(el => el.classList.remove('hidden'))
      inSections.forEach(el => el.classList.add('hidden'))
      toggleLabels.forEach(el => { el.textContent = 'Switch to: IN' })
    }
  }
}
